export const ModalStateName = 'ModalStateComponent';
